import { clsx } from 'clsx';
import { ChevronDownIcon } from 'lucide-react';

import { Section } from '../section/index.ts';

import styles from './faq-section.module.css';

export type FaqItem = {
  title: string;
  content: React.ReactNode;
};

export const FaqSection = (props: { items: FaqItem[] }) => {
  return (
    <Section.Container className="bg-white">
      <Section.Content size="sm" className="flex flex-col gap-4 py-10">
        <h2 className="text-center typography-v1-h1">FAQ</h2>

        <div>
          {props.items.map((item) => (
            <FaqAccordion key={item.title} item={item} />
          ))}
        </div>
      </Section.Content>
    </Section.Container>
  );
};

const FaqAccordion = (props: { item: FaqItem }) => {
  return (
    <details
      className={clsx('border-b border-v1-neutral-20 py-4 last:border-b-0', styles.accordion)}
    >
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-4 text-left typography-v1-h3 [&::-webkit-details-marker]:hidden">
        {props.item.title}
        <ChevronDownIcon
          aria-hidden="true"
          className={clsx('size-5 shrink-0 text-v1-neutral-100', styles.chevron)}
        />
      </summary>

      <div className="px-4 py-2 typography-v1-body4">{props.item.content}</div>
    </details>
  );
};
